import { VALID_IDENTIFIER_RE } from '@views/Logs/utils/normalize-facet';
import { entityProjectionNames } from './entityProjectionNames';

export type RelatedEntityQueryConfig = {
  targetTable: string;
  relationshipField: string;
  relatedProjName?: string;
  keyPrefix?: string;
  keyField?: string;
};

export const entityRelationshipQueryConfig: Record<string, RelatedEntityQueryConfig> = {
  [entityProjectionNames.Exception]: {
    targetTable: 'uber_findings',
    relationshipField: 'finding_rule_based_exception',
    relatedProjName: 'uber_findings',
    keyPrefix: 'finding',
  },
  uber_exceptions_entity_ticket: {
    targetTable: 'uber_findings',
    relationshipField: 'ticket',
    keyPrefix: 'finding',
  },
  uber_exceptions_rule_ticket: {
    targetTable: 'tickets',
    relationshipField: 'ticket_rule_based_exception',
    relatedProjName: 'tickets',
    keyPrefix: 'ticket',
  },
  uber_exceptions_related: {
    targetTable: 'uber_exceptions',
    relationshipField: 'exception',
    keyField: 'related_entity_key',
    keyPrefix: 'exception',
  },
};

const isValidSqlIdentifier = (fieldName: string): boolean => VALID_IDENTIFIER_RE.test(fieldName);

export const getRelatedEntityQueryConfig = (projectionName: string): RelatedEntityQueryConfig | null => {
  const config = entityRelationshipQueryConfig[projectionName];
  if (!config) {
    return null;
  }

  if (!isValidSqlIdentifier(config.relationshipField)) {
    console.error(`Invalid relationshipField in config: ${config.relationshipField}`);
    return null;
  }

  return config;
};
